<template>
    <div>
        <transition name="fade">
            <div v-if="loading" class="loading">
                <p>Loading</p>
            </div>
        </transition>
        <b-container fluid>
            <Consumerorderscomponent  :ordersArray="consumerOrders" />
        </b-container>
        <footer><pagefooter/></footer>
        
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import Consumerorderscomponent from './Consumerorderscomponent'
    const fb = require('../../firebaseConfig.js')

    import Pagefooter from '../Pagefooter'
    export default {
        components: {
            Consumerorderscomponent,
            Pagefooter,
            },
        computed: {
            ...mapState(['userProfile', 'currentUser', 'consumerOrders'])
        },
        data() {
            return {       
                loading:false,    

            }
        },

        methods:{


        }
        
    }
</script>